/**
 * 全局共享数据，初始化全局配置
 */
import { webview, ua, query } from '@kk/utils';

process.env.VUE_APP_HOST_ENV !== 'production' && console.info('准备初始化globalData');
// Apple UA列表：https://wiki.quickcan.com/pages/viewpage.action?pageId=351011925
// IOS 14支持webp： https://developer.apple.com/documentation/safari-release-notes/safari-14-release-notes
const userAgent = navigator.userAgent.toLowerCase();
const iosMajorVersion = (userAgent.match(/(cpu\s+iphone\s+os|cpu\s+os)\s+(\d+)(_\d+){0,2}/) || [
    '',
    '',
    '0',
    '_0',
    '_0',
])[2];
const appleWebpSupported = /chrome/.test(userAgent) || iosMajorVersion >= 14;

let bafa = parseInt(query.get('bafa'), 10);
if (Number.isNaN(bafa)) {
    bafa = 0;
}
let bafi = parseInt(query.get('bafi'), 10);
if (Number.isNaN(bafi)) {
    bafi = 0;
}

/**
 * 这里面不要乱塞东西
 * 如果一定要加东西，请使用一个不怎么常用的名称
 * 太通用的名字，会导致引入公司其他组提供的组件时候，出现名称的冲突
 */
const globalData = {
    uid: null,
    app_version: null,
    device_id: null,
    os: null,
    isLogin: false,
    isApple: webview.isApple,
    isKuaikan: webview.isKuaikan,
    isWeixin: webview.isWeixin,
    isAndroid: webview.isAndroid,
    isKuaiKanMiniprogram: ua.miniprogram,
    miniversion: ua.miniversion,
    appleWebpSupported, // 是否支持webp图片
    isOutside: !(webview.isKuaikan || ua.miniprogram), // 端外环境
    innerPreview: query.get('innerPreview') === '1',
    prewViewId: query.get('prewViewId'),
    innerPreviewActiveTime: query.get('innerPreviewActiveTime') || '' + new Date().getTime(),
    innerPreviewInitData: query.get('innerPreviewInitData'),
    userNewClassificationIds: query.get('userNewClassificationIds'),
    platformType: query.get('platformType'),
    priviewUid: query.get('priviewUid'),
    visitSource: parseInt(query.get('visitsource'), 10) || 0,
    /**
     * 是端内类发现页容器
     */
    isFindTabLikeContainer: query.get('hideback') === '1' && webview.isKuaikan,
    bafa: bafa,
    bafi: bafi,
};

process.env.VUE_APP_HOST_ENV !== 'production' &&
    console.info('初始化globalData完毕，globalData为：', JSON.stringify(globalData));

if (process.env.VUE_APP_HOST_ENV === 'e2e') {
    // e2e测试中暴露全局对象
    window.__e2e__pageAction_globalData = globalData;
}

export default globalData;
